import { Pipe, PipeTransform } from '@angular/core';

import { FlyoutIndustryCatalog } from '@mp/content-manager/plattformkataloge/data-access';

@Pipe({ name: 'isSelectedById' })
export class IsSelectedByIdPipe<T extends string | number> implements PipeTransform {
  transform(id: T, selection: Array<FlyoutIndustryCatalog>): boolean {
    return selection.some((item) => item.catalogId === id);
  }
}
